import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/api";
import { getClientId } from "../lib/clientId";
import { getSessionSource } from "../lib/session";

export const RouteTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageView(pathname, getClientId(), getSessionSource());
  }, [pathname]);
  return null;
};
